/**
 * One-navigation handoff between a page that subscribes someone to Weekly Specials and the homepage
 * dialog that confirms it.
 *
 * sessionStorage rather than localStorage: a stale localStorage key survives browser restarts and
 * would pop the dialog on an unrelated visit. Every accessor is wrapped because the storage
 * accessor itself throws in some privacy modes.
 */
const HANDOFF_KEY = "subscribeSuccessOrigin";

/** Record that a subscribe succeeded on `originPath`, to be confirmed after navigating home. */
export function setSubscribeSuccessOrigin(originPath: string): void {
  try {
    window.sessionStorage.setItem(HANDOFF_KEY, originPath);
  } catch {
    // Losing the dialog must never break the subscribe itself.
  }
}

/**
 * Read and clear the handoff. Returns the originating path, or null when there is nothing pending.
 * Always clears, so a refresh of the homepage does not replay the dialog.
 */
export function consumeSubscribeSuccessOrigin(): string | null {
  try {
    const origin = window.sessionStorage.getItem(HANDOFF_KEY);
    if (origin) {
      window.sessionStorage.removeItem(HANDOFF_KEY);
    }
    return origin;
  } catch {
    return null;
  }
}
